
import TransductionActions from "./TransductionActions";

export default TransductionActions;